import React from "react";
import { Link } from "react-router-dom";
import profile from "../../images/profile.svg";
import services from "../../images/services.svg";
import setting from "../../images/settings.svg";
import lastlogindetails from "../../images/lastlogindetails.svg";
import Accommodationlrg from "../../images/Accommodation-lrg.svg";
import Asswssmentlrg from "../../images/Asswssment-lrg.svg";
import LanguageConfirmationModalPopup from "../../containers/Std/LanguageConfirmationModalPopup";
import history from "../../utilities/history";
import Backbutton from "../../containers/Common/Backbutton";
import LastLoginDetails from "../../containers/LastLoginDetails";
import { MODAL_SIZE } from "../../App.config";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";


function AccountSettingComponent(props) {
  const modules = [
    {
      count: 1,
      logo: profile,
      heading: props.context.t("Setting.My.Profile.text"),
      redirectLinkName: props.context.t("Setting.View.text"),
      redirectLink: "/profile",
    },
    {
      count: 2,
      logo: lastlogindetails,
      heading: props.context.t("Setting.Last.Login.Details.text"),
      redirectLinkName: props.context.t("Setting.View.text"),
      redirectLink: "",
    },
    {
      count: 4,
      logo: setting,
      heading: props.context.t("Setting.Settings.text"),
      redirectLinkName: props.context.t("STD-Dashboard.label.heading.btn-1"),
      redirectLink: "/mysettings",
    },
  ];

  const onServiceButtonClick = (path) => {
    if (!path) {
      openModal();
      return;
    }
    history.push(path);
  };

  const openModal = () => {
    props.openSetModalAction(<LastLoginDetails />, MODAL_SIZE.MODAL_SM);
  };

  return (
    <div className="Dashboard-service">
      <div className="row">
        <div className="back-btn-outer">

          <Backbutton />
        </div>
      </div>
      <div className="service-box">
      <DisplayEmployeeName  context={props.context}/>
        <div className="row">
          {modules.map((module) => (
            <div
              key={module.heading}
              className="col-12 col-sm-12 col-md-12 col-lg-4"
            >
              <div className="s-box">
                <div className="srv-img">
                  <img src={module.logo} alt="" />
                </div>
                <h2>{module.heading}</h2>

                <div
                  onClick={() => {
                    onServiceButtonClick(module.redirectLink);
                  }}
                  className="r-more"
                >
                  {module.redirectLinkName}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default AccountSettingComponent;
